import { render, staticRenderFns } from "./api-settings-tab.vue?vue&type=template&id=8fe6477a&scoped=true"
import script from "./api-settings-tab.vue?vue&type=script&lang=js"
export * from "./api-settings-tab.vue?vue&type=script&lang=js"
import style0 from "./api-settings-tab.vue?vue&type=style&index=0&id=8fe6477a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe6477a",
  null
  
)

export default component.exports